import { RootState } from '../../app/store';

export const selectUser = (state: RootState) => {
    return state.user;
};

export const selectIsAuthenticated = (state: RootState) => {
    return state.authentication.isAuthenticated;
};
